export default __webpack_public_path__ + "media/WandB.03303d15.svg";